// frontend/src/pages/QuantumIdentityPage.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CrystalGoogleButton from "../components/CrystalGoogleButton"; // ✅ AJOUT
import ContactForm from "../components/ContactForm"; // ✅ AJOUT
import { useAuth } from "../context/AuthContext"; // ✅ M26.21

export default function QuantumIdentityPage() {
  const navigate = useNavigate();
  const { user, authenticated, isAdmin, loading: authLoading, onLoginSuccess, onLogout } = useAuth();
  const [loading, setLoading] = useState(false);

  // États du Dashboard
  const [mode, setMode] = useState("INDUSTRY");
  const [formData, setFormData] = useState({});
  const [showInfoModal, setShowInfoModal] = useState(false); // ✅ Info Modal State
  const [generatedQuid, setGeneratedQuid] = useState(null);
  const [history, setHistory] = useState([]);
  const [selectedCert, setSelectedCert] = useState(null); // ✅ MODAL STATE
  const [showContact, setShowContact] = useState(false); // ✅ AJOUT : État pour le formulaire de contact
  const [showDeleteModal, setShowDeleteModal] = useState(false); // ✅ RGPD : Modale suppression
  const [deleteConfirmChecked, setDeleteConfirmChecked] = useState(false); // ✅ RGPD : Double confirmation


  // --- NOUVEAUX STATES POUR LE MODE SANTÉ ---
  const [healthFields, setHealthFields] = useState([{ key: "", value: "" }]);
  const [showReview, setShowReview] = useState(false);

  const addHealthField = () => {
    setHealthFields([...healthFields, { key: "", value: "" }]);
  };

  const removeHealthField = (index) => {
    if (healthFields.length > 1) {
      setHealthFields(healthFields.filter((_, i) => i !== index));
    } else {
      setHealthFields([{ key: "", value: "" }]);
    }
  };

  const updateHealthField = (index, field, val) => {
    const newFields = [...healthFields];
    newFields[index][field] = val;
    setHealthFields(newFields);
  };
  // ------------------------------------------

  // ✅ UX/LEGAL: Checkbox Consentement
  const [consentChecked, setConsentChecked] = useState(false);

  useEffect(() => {
    if (authenticated) {
      fetchHistory();
    }
  }, [authenticated]);

  const fetchHistory = () => {
    fetch("/api/quid/list")
      .then(res => res.json())
      .then(data => setHistory(data))
      .catch(err => console.error(err));
  };

  const handleGoogleSuccess = async (tokenResponse) => {
    setLoading(true);
    try {
      const body = {};
      if (tokenResponse.credential) {
        body.id_token = tokenResponse.credential;
      } else if (tokenResponse.access_token) {
        body.access_token = tokenResponse.access_token;
      }

      const res = await fetch("/api/auth/login/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.status === "success") {
        // ✅ M26.21: Rafraîchir le contexte auth centralisé
        await onLoginSuccess();
        fetchHistory();
      } else {
        alert("Erreur Connexion: " + data.message);
      }
    } catch (err) {
      alert("Erreur connexion Google");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await onLogout();
    setGeneratedQuid(null);
    navigate("/");
  };

  const handleDeleteAccount = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/auth/delete-account", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      });
      const data = await res.json();
      if (data.status === "success") {
        await onLogout();
        setGeneratedQuid(null);
        setShowDeleteModal(false);
        navigate("/");
      } else {
        alert("Erreur lors de la suppression : " + data.message);
      }
    } catch (err) {
      alert("Erreur lors de la communication avec le serveur.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportData = () => {
    try {
      const exportPayload = {
        export_metadata: {
          app: "Oracle d'Entropie Quantique",
          exported_at: new Date().toISOString(),
          version: "RGPD-v1.0"
        },
        user_profile: {
          name: user.name,
          email: user.email,
          role: user.role
        },
        certificates: history.map(c => ({
          quid: c.quid,
          category: c.category,
          metadata: c.metadata,
          created_at: c.created_at
        }))
      };
      
      const blob = new Blob([JSON.stringify(exportPayload, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `quantum_identity_export_${Date.now()}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      alert("Erreur lors de l'export des données : " + err.message);
    }
  };



  const handleGenerate = async (customMetadata = null) => {
    if (!user) return;
    const finalMetadata = customMetadata || formData;
    try {
      const res = await fetch("/api/quid/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category: mode, metadata: finalMetadata })
      });
      const data = await res.json();
      if (data.status === "success") {
        setGeneratedQuid(data);
        fetchHistory();
        setFormData({});
        setHealthFields([{ key: "", value: "" }]); // Reset les champs santé
        setShowReview(false); // Reset l'écran de validation
      } else {
        alert("Erreur: " + data.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // --- RENDU ---

  const renderLanding = () => (
    <div style={{ textAlign: "center", padding: "60px 20px", color: "#fff", position: "relative" }}>

      <Link to="/" style={{
        position: "absolute", top: 0, left: "20px",
        color: "#666", textDecoration: "none", fontSize: "0.9rem",
        display: "flex", alignItems: "center", gap: "5px"
      }}>
        ← Retour Accueil
      </Link>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "0", background: "linear-gradient(to right, #00f260, #0575E6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          Quantum Unique Identifier
        </h1>
        <button
          onClick={() => setShowInfoModal(true)}
          style={{
            background: "rgba(0, 255, 255, 0.1)", border: "1px solid #0ff", color: "#0ff",
            borderRadius: "50%", width: "24px", height: "24px", fontSize: "0.9rem",
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
            marginTop: "10px"
          }}
          title="Comprendre QUID"
        >
          i
        </button>
      </div>
      <div style={{ marginBottom: "20px" }}></div>
      <p style={{
        fontSize: "1.2rem", maxWidth: "600px", margin: "0 auto 40px", color: "#eee",
        background: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(4px)", padding: "15px", borderRadius: "10px", display: "inline-block"
      }}>
        La première plateforme de certification d'objets et de documents par entropie quantique.
        <br />Traçabilité infalsifiable pour l'Industrie, le Luxe et l'Événementiel.
      </p>

      <div style={{ background: "rgba(17, 17, 17, 0.75)", backdropFilter: "blur(12px)", padding: "30px", borderRadius: "12px", display: "inline-block", border: "1px solid #333" }}>
        <p style={{ marginBottom: "20px" }}>Accès réservé aux partenaires certifiés.</p>

        {/* ✅ UX/LEGAL : Checkbox Consentement Obligatoire */}
        <div style={{ marginBottom: "20px", fontSize: "0.85rem", color: "#ccc", textAlign: "left", maxWidth: "300px" }}>
          <label style={{ display: "flex", gap: "10px", alignItems: "start", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={consentChecked}
              onChange={(e) => setConsentChecked(e.target.checked)}
              style={{ marginTop: "3px" }}
            />
            <span>
              J'ai lu et j'accepte la <Link to="/privacy" target="_blank" style={{ color: "#0ff" }}>Politique de Confidentialité</Link>, les <Link to="/terms" target="_blank" style={{ color: "#0ff" }}>Conditions d'Utilisation</Link> et la <Link to="/retention-policy" target="_blank" style={{ color: "#0ff" }}>Politique de Rétention</Link>.
            </span>
          </label>
        </div>

        {/* ✅ REMPLACEMENT : Bouton Crystal Google */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CrystalGoogleButton
            onSuccess={handleGoogleSuccess}
            onError={() => alert("Échec connexion Google")}
            disabled={!consentChecked}
          />
        </div>
      </div>

      <div style={{ marginTop: "40px" }}>
        <button onClick={() => setShowContact(!showContact)} style={{ background: "#333", border: "1px solid #666", color: "#fff", padding: "10px 20px", cursor: "pointer", borderRadius: "6px", fontWeight: "bold" }}>
          {showContact ? "Masquer Contact" : "Nous Contacter"}
        </button>
        {showContact && <ContactForm />}
      </div>

      {/* ✅ MODAL INFO QUID */}
      {showInfoModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.8)", backdropFilter: "blur(5px)", zIndex: 9999,
          display: "flex", justifyContent: "center", alignItems: "center", textAlign: "left"
        }} onClick={() => setShowInfoModal(false)}>
          <div style={{
            background: "rgba(20, 30, 50, 0.95)", border: "1px solid #0ff", padding: "30px", borderRadius: "16px",
            maxWidth: "600px", width: "90%", boxShadow: "0 0 50px rgba(0, 255, 255, 0.2)",
            color: "#fff", position: "relative", maxHeight: "90vh", overflowY: "auto"
          }} onClick={e => e.stopPropagation()}>

            <h2 style={{ borderBottom: "1px solid #333", paddingBottom: "10px", marginBottom: "20px", color: "#0ff" }}>
              Certification & Traçabilité Quantique
            </h2>

            <div style={{ lineHeight: "1.6" }}>
              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>1. Le Concept QUID</h3>
              <p style={{ color: "#ddd" }}>
                Créez le <strong>"Jumeau Numérique"</strong> de vos objets de valeur (Montres, Sacs, Documents, Équipements). Chaque certificat est scellé par une signature quantique unique.
              </p>

              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>2. Anti-Contrefaçon</h3>
              <p style={{ color: "#ddd" }}>
                Grâce à l'unicité du numéro de série et à l'<strong>empreinte entropique</strong>, il devient impossible de dupliquer un certificat ou de falsifier l'origine d'un produit.
              </p>

              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>3. Industries</h3>
              <p style={{ color: "#ddd" }}>
                Idéal pour garantir l'authenticité dans le <strong>Luxe</strong>, suivre la maintenance dans l'<strong>Industrie</strong>, ou sécuriser la billetterie dans l'<strong>Événementiel</strong>.
              </p>
            </div>

            <button onClick={() => setShowInfoModal(false)} style={{
              marginTop: "25px", width: "100%", padding: "12px", background: "#333", color: "#fff",
              border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold"
            }}>
              Fermer
            </button>

          </div>
        </div>
      )}

    </div>
  );

  const renderDashboard = () => (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto", color: "#eee" }}>
      {/* Header Dashboard */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px", borderBottom: "1px solid #333", padding: "20px", background: "rgba(0,0,0,0.8)", borderRadius: "8px" }}>
        <div>
          <h2 style={{ margin: 0 }}>Tableau de Bord QUID</h2>
          <small style={{ color: "#888" }}>Connecté en tant que : {user.name} ({user.email})</small>
        </div>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <button onClick={handleLogout} style={{ background: "transparent", border: "1px solid #555", color: "#aaa", padding: "5px 15px", cursor: "pointer", borderRadius: "4px" }}>
            Déconnexion
          </button>
          <button 
            onClick={() => { setShowDeleteModal(true); setDeleteConfirmChecked(false); }} 
            className="delete-acc-btn"
            style={{ 
              background: "rgba(220, 53, 69, 0.1)", 
              border: "1px solid #dc3545", 
              color: "#dc3545", 
              padding: "5px 15px", 
              cursor: "pointer",
              borderRadius: "4px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
          >
            Supprimer mon compte
          </button>
        </div>
      </div>


      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px" }}>
        {/* Colonne Gauche : Générateur */}
        <div>
          <h3 style={{ color: "#0ff", background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", padding: "5px 15px", borderRadius: "8px", display: "inline-block", marginBottom: "15px" }}>Nouveau Certificat</h3>
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
            {["INDUSTRY", "LUXE", "EVENT", "SANTE"].map(m => (
              <button 
                key={m} 
                onClick={() => { setMode(m); setShowReview(false); }} 
                style={{ flex: 1, padding: "10px", background: mode === m ? "rgba(0, 255, 255, 0.1)" : "#222", border: mode === m ? "1px solid #0ff" : "1px solid #333", color: mode === m ? "#0ff" : "#888", cursor: "pointer", fontWeight: "bold" }}
              >
                {m === "INDUSTRY" && "🏭 Industrie"}
                {m === "LUXE" && "💎 Luxe"}
                {m === "EVENT" && "🎟️ Event"}
                {m === "SANTE" && "🏥 Santé"}
              </button>
            ))}
          </div>

          <div style={{ background: "rgba(26, 26, 26, 0.75)", backdropFilter: "blur(12px)", padding: "20px", borderRadius: "8px", border: "1px solid #333" }}>
            {mode === "INDUSTRY" && (<><div style={{ marginBottom: 15 }}><label>Nom de l'Usine</label><input style={inputStyle} onChange={e => setFormData({ ...formData, factory: e.target.value })} /></div><div style={{ marginBottom: 15 }}><label>Numéro de Lot</label><input style={inputStyle} onChange={e => setFormData({ ...formData, batch: e.target.value })} /></div></>)}
            {mode === "LUXE" && (<><div style={{ marginBottom: 15 }}><label>Objet / Modèle</label><input style={inputStyle} onChange={e => setFormData({ ...formData, item: e.target.value })} /></div><div style={{ marginBottom: 15 }}><label>Numéro de Série Interne</label><input style={inputStyle} onChange={e => setFormData({ ...formData, serial: e.target.value })} /></div></>)}
            {mode === "EVENT" && (<><div style={{ marginBottom: 15 }}><label>Nom de l'événement</label><input style={inputStyle} onChange={e => setFormData({ ...formData, event: e.target.value })} /></div><div style={{ marginBottom: 15 }}><label>Type de place</label><input style={inputStyle} onChange={e => setFormData({ ...formData, seat: e.target.value })} /></div></>)}

            {/* NOUVEAU : FORMULAIRE DYNAMIQUE SANTÉ */}
            {mode === "SANTE" && !showReview && (
              <>
                {healthFields.map((field, i) => (
                  <div key={i} style={{ display: "flex", gap: "10px", marginBottom: "15px", alignItems: "flex-end" }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: "0.85rem", color: "#aaa" }}>Nom du champ</label>
                      <input style={inputStyle} value={field.key} onChange={e => updateHealthField(i, 'key', e.target.value)} placeholder="Ex: Groupe Sanguin" />
                    </div>
                    <div style={{ flex: 2 }}>
                      <label style={{ fontSize: "0.85rem", color: "#aaa" }}>Valeur</label>
                      <input style={inputStyle} value={field.value} onChange={e => updateHealthField(i, 'value', e.target.value)} placeholder="Ex: O+" />
                    </div>
                    <button 
                      onClick={() => removeHealthField(i)}
                      style={{ padding: "8px 12px", background: "rgba(220, 53, 69, 0.15)", border: "1px solid #dc3545", color: "#dc3545", borderRadius: "4px", cursor: "pointer", height: "38px" }}
                      title="Supprimer ce champ"
                    >
                      🗑️
                    </button>
                  </div>
                ))}
                <button onClick={addHealthField} style={{ padding: "8px", background: "transparent", color: "#0ff", border: "1px dashed #0ff", borderRadius: "4px", cursor: "pointer", marginBottom: "15px", width: "100%", fontWeight: "bold" }}>
                  + Ajouter un champ
                </button>
              </>
            )}

            {/* NOUVEAU : ÉCRAN DE VALIDATION (REVIEW & CONFIRM) */}
            {mode === "SANTE" && showReview && (
              <div style={{ marginBottom: "20px", padding: "15px", border: "1px solid #ffaa00", borderRadius: "5px", background: "rgba(255, 170, 0, 0.1)" }}>
                <h3 style={{ color: "#ffaa00", marginTop: 0, fontSize: "1.1em", display: "flex", alignItems: "center", gap: "8px" }}>⚠️ Vérification avant scellement</h3>
                <p style={{ fontSize: "0.9em", color: "#ddd" }}>Veuillez confirmer l'exactitude de ces données de santé avant la signature on-chain :</p>
                <ul style={{ paddingLeft: "20px", color: "#fff", listStyleType: "square" }}>
                  {healthFields.map((f, i) => (
                      <li key={i} style={{ marginBottom: "8px" }}>
                        <span style={{ color: "#0ff", fontWeight: "bold" }}>{f.key || "Champ sans nom"} :</span> {f.value || "Aucune valeur"}
                      </li>
                  ))}
                </ul>
              </div>
            )}

            {/* BOUTONS D'ACTION DYNAMIQUES */}
            {mode !== "SANTE" && (
              <button onClick={() => handleGenerate()} style={{ width: "100%", padding: "12px", background: "#0ff", border: "none", color: "#000", fontWeight: "bold", marginTop: "10px", cursor: "pointer", borderRadius: "4px" }}>
                GÉNÉRER LE CERTIFICAT QUANTIQUE
              </button>
            )}

            {mode === "SANTE" && !showReview && (
              <button 
                onClick={() => {
                  const hasValidField = healthFields.some(f => f.key.trim() !== "");
                  if (!hasValidField) {
                    alert("Veuillez saisir au moins un champ valide.");
                    return;
                  }
                  setShowReview(true);
                }} 
                style={{ width: "100%", padding: "12px", background: "#0ff", border: "none", color: "#000", fontWeight: "bold", marginTop: "10px", cursor: "pointer", borderRadius: "4px" }}
              >
                VÉRIFIER LES DONNÉES
              </button>
            )}

            {mode === "SANTE" && showReview && (
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button onClick={() => setShowReview(false)} style={{ flex: 1, padding: "12px", background: "transparent", border: "1px solid #777", color: "#fff", fontWeight: "bold", cursor: "pointer", borderRadius: "4px" }}>
                  CORRIGER
                </button>
                <button onClick={() => {
                  const customData = healthFields.reduce((acc, curr) => {
                    if (curr.key.trim()) acc[curr.key.trim()] = curr.value.trim();
                    return acc;
                  }, {});
                  
                  // Injecte les données en paramètre direct pour éviter le batching d'état asynchrone
                  handleGenerate({ customHealthData: JSON.stringify(customData) });
                }} style={{ flex: 2, padding: "12px", background: "#10b981", border: "none", color: "#000", fontWeight: "bold", cursor: "pointer", borderRadius: "4px" }}>
                  VALIDER & SIGNER
                </button>
              </div>
            )}
          </div>

          {generatedQuid && (
            <div style={{ marginTop: "20px", padding: "15px", background: "rgba(0, 255, 0, 0.1)", border: "1px solid #0f0", borderRadius: "8px" }}>
              <h4 style={{ margin: "0 0 10px 0", color: "#0f0" }}>✅ QUID Créé avec succès</h4>
              <div style={{ fontFamily: "monospace", wordBreak: "break-all", fontSize: "1.1rem" }}>{generatedQuid.quid}</div>
              <small style={{ color: "#aaa" }}>Timestamp: {generatedQuid.timestamp}</small>
            </div>
          )}
        </div>

        {/* Colonne Droite : Historique */}
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
            <h3 style={{ color: "#ccc", background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", padding: "5px 15px", borderRadius: "8px", display: "inline-block", margin: 0 }}>Vos Certificats Récents</h3>
            <button 
              onClick={handleExportData} 
              style={{
                background: "rgba(0, 255, 255, 0.08)",
                border: "1px solid rgba(0, 255, 255, 0.3)",
                color: "#00ffff",
                padding: "6px 12px",
                borderRadius: "6px",
                fontSize: "0.8rem",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.2s"
              }}
              onMouseOver={e => e.currentTarget.style.background = "rgba(0, 255, 255, 0.15)"}
              onMouseOut={e => e.currentTarget.style.background = "rgba(0, 255, 255, 0.08)"}
            >
              📥 Exporter Données (JSON)
            </button>
          </div>
          <div style={{ maxHeight: "500px", overflowY: "auto", background: "rgba(17, 17, 17, 0.75)", backdropFilter: "blur(12px)", border: "1px solid #333", borderRadius: "8px" }}>
            {history.length === 0 ? (<p style={{ padding: "20px", color: "#555", textAlign: "center" }}>Aucun certificat généré.</p>) : (
              history.map((h, i) => (
                <div key={i} onClick={() => setSelectedCert(h)} style={{ padding: "15px", borderBottom: "1px solid #222", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", transition: "background 0.2s" }} onMouseOver={e => e.currentTarget.style.background = "rgba(255,255,255,0.05)"} onMouseOut={e => e.currentTarget.style.background = "transparent"}>
                  <div>
                    <span style={{ fontSize: "0.7rem", padding: "2px 6px", borderRadius: "4px", marginRight: "10px", background: h.category === "SANTE" ? "#10b981" : h.category === "INDUSTRY" ? "#007bff" : h.category === "LUXE" ? "#6f42c1" : "#e83e8c", color: "#fff" }}>{h.category}</span>
                    <span style={{ fontFamily: "monospace", color: "#ddd" }}>{h.quid.substring(0, 16)}...</span>
                  </div>
                  <div style={{ fontSize: "0.8rem", color: "#666" }}>{new Date(h.created_at).toLocaleDateString()}</div>
                </div>
              ))
            )}
          </div>

          <div style={{ marginTop: "40px" }}>
            <button onClick={() => setShowContact(!showContact)} style={{ background: "#333", border: "1px solid #666", color: "#fff", padding: "10px 20px", cursor: "pointer", borderRadius: "6px", fontWeight: "bold" }}>
              {showContact ? "Masquer Contact" : "Signaler un problème"}
            </button>
            {showContact && <ContactForm />}
          </div>
        </div>
      </div>

      {/* ✅ MODAL DETAILS CERTIFICAT */}
      {selectedCert && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.8)", backdropFilter: "blur(5px)", zIndex: 9999,
          display: "flex", justifyContent: "center", alignItems: "center"
        }} onClick={() => setSelectedCert(null)}>
          <div style={{
            background: "rgba(20, 30, 50, 0.9)", border: "1px solid #0ff", padding: "30px", borderRadius: "16px",
            maxWidth: "500px", width: "90%", boxShadow: "0 0 50px rgba(0, 255, 255, 0.2)",
            color: "#fff", position: "relative"
          }} onClick={e => e.stopPropagation()}>

            <h2 style={{ borderBottom: "1px solid #333", paddingBottom: "10px", marginBottom: "20px", color: "#0ff" }}>
              Fiche d'Identité QUID
            </h2>

            <div style={{ display: "grid", gap: "15px", fontSize: "1rem" }}>
              <div>
                <span style={{ color: "#888", display: "block", fontSize: "0.8rem" }}>CATÉGORIE</span>
                <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                  {selectedCert.category === "INDUSTRY" && "🏭 INDUSTRIE"}
                  {selectedCert.category === "LUXE" && "💎 LUXE"}
                  {selectedCert.category === "EVENT" && "🎟️ ÉVÉNEMENT"}
                  {selectedCert.category === "SANTE" && "🏥 SANTÉ"}
                </span>
              </div>

              {/* Affichage intelligent des métadonnées */}
              {selectedCert.metadata && (
                <>
                  {selectedCert.metadata.factory && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>USINE</span><br />{selectedCert.metadata.factory}</div>}
                  {selectedCert.metadata.batch && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>LOT</span><br />{selectedCert.metadata.batch}</div>}
                  {selectedCert.metadata.item && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>MODÈLE</span><br />{selectedCert.metadata.item}</div>}
                  {selectedCert.metadata.serial && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>SÉRIE</span><br />{selectedCert.metadata.serial}</div>}
                  {selectedCert.metadata.event && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>ÉVÉNEMENT</span><br />{selectedCert.metadata.event}</div>}
                  {selectedCert.metadata.seat && <div><span style={{ color: "#888", fontSize: "0.8rem" }}>PLACE</span><br />{selectedCert.metadata.seat}</div>}
                  
                  {/* Rendu intelligent des données de santé dynamiques en JSON */}
                  {selectedCert.category === "SANTE" && selectedCert.metadata.customHealthData && (() => {
                    try {
                      const parsed = JSON.parse(selectedCert.metadata.customHealthData);
                      return Object.entries(parsed).map(([key, value]) => (
                        <div key={key} style={{ borderLeft: "2px solid #10b981", paddingLeft: "10px", margin: "5px 0" }}>
                          <span style={{ color: "#10b981", fontSize: "0.8rem", fontWeight: "bold" }}>{key.toUpperCase()}</span>
                          <br />{value}
                        </div>
                      ));
                    } catch (e) {
                      return <div><span style={{ color: "#888", fontSize: "0.8rem" }}>DONNÉES MÉDICALES (BRUT)</span><br />{selectedCert.metadata.customHealthData}</div>;
                    }
                  })()}
                </>
              )}

              <div style={{ marginTop: "10px" }}>
                <span style={{ color: "#888", display: "block", fontSize: "0.8rem" }}>SIGNATURE QUANTIQUE (HASH)</span>
                <div style={{
                  fontFamily: "monospace", wordBreak: "break-all", background: "#000",
                  padding: "10px", borderRadius: "6px", border: "1px solid #005555", color: "#0ff"
                }}>
                  {selectedCert.quid}
                </div>
              </div>

              <div>
                <span style={{ color: "#888", display: "block", fontSize: "0.8rem" }}>DATE DE CRÉATION</span>
                {new Date(selectedCert.created_at).toLocaleString()}
              </div>
            </div>

            <button onClick={() => setSelectedCert(null)} style={{
              marginTop: "25px", width: "100%", padding: "12px", background: "#333", color: "#fff",
              border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold"
            }}>
              Fermer
            </button>

          </div>
        </div>
      )}

      {/* ✅ MODAL SUPPRESSION COMPTE */}
      {showDeleteModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.85)", backdropFilter: "blur(6px)", zIndex: 99999,
          display: "flex", justifyContent: "center", alignItems: "center"
        }} onClick={() => setShowDeleteModal(false)}>
          <div style={{
            background: "rgba(25, 15, 20, 0.95)", border: "1px solid #dc3545", padding: "30px", borderRadius: "16px",
            maxWidth: "500px", width: "90%", boxShadow: "0 0 50px rgba(220, 53, 69, 0.15)",
            color: "#fff", position: "relative"
          }} onClick={e => e.stopPropagation()}>

            <h2 style={{ borderBottom: "1px solid #3d1a1d", paddingBottom: "10px", marginBottom: "20px", color: "#ff4d4d", display: "flex", alignItems: "center", gap: "10px" }}>
              ⚠️ Suppression définitive du compte
            </h2>

            <div style={{ lineHeight: "1.6", fontSize: "0.95rem", color: "#ddd" }}>
              <p>
                Cette action est <strong>irréversible</strong>. Vos données d'accès (Nom, Adresse e-mail, Photo de profil) seront définitivement effacées de nos serveurs.
              </p>
              <p style={{ marginTop: "10px", background: "rgba(220,53,69,0.1)", padding: "12px", borderRadius: "8px", borderLeft: "4px solid #dc3545" }}>
                <strong>Conformité Blockchain (RGPD) :</strong> Vos certificats d'objets (QUID) existants resteront enregistrés dans le registre pour garantir l'intégrité cryptographique de l'historique de la chaîne, mais ils seront <strong>totalement anonymisés</strong>. Toute association avec votre personne physique sera définitivement rompue.
              </p>

              <label style={{ display: "flex", gap: "10px", alignItems: "start", marginTop: "20px", cursor: "pointer", userSelect: "none" }}>
                <input 
                  type="checkbox" 
                  checked={deleteConfirmChecked} 
                  onChange={e => setDeleteConfirmChecked(e.target.checked)} 
                  style={{ marginTop: "4px" }}
                />
                <span style={{ fontSize: "0.85rem", color: "#bbb" }}>
                  Je comprends que cette action est définitive et que je ne pourrai pas récupérer mes accès ou mes données liées.
                </span>
              </label>
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "30px" }}>
              <button onClick={() => setShowDeleteModal(false)} style={{ flex: 1, padding: "12px", background: "#333", border: "1px solid #555", color: "#fff", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}>
                Annuler
              </button>
              <button 
                onClick={handleDeleteAccount} 
                disabled={!deleteConfirmChecked} 
                style={{ 
                  flex: 1, 
                  padding: "12px", 
                  background: deleteConfirmChecked ? "#dc3545" : "rgba(220, 53, 69, 0.2)", 
                  border: "none", 
                  color: deleteConfirmChecked ? "#fff" : "#888", 
                  borderRadius: "8px", 
                  cursor: deleteConfirmChecked ? "pointer" : "not-allowed", 
                  fontWeight: "bold",
                  transition: "all 0.2s" 
                }}
              >
                Confirmer la suppression
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );

  const inputStyle = { width: "100%", padding: "8px", background: "#222", border: "1px solid #444", color: "#fff", borderRadius: "4px", marginTop: "5px" };

  if (loading || authLoading) return <><div style={{ padding: "50px", textAlign: "center", color: "#fff" }}>Chargement...</div></>;

  return (
    <>
      {authenticated && user ? renderDashboard() : renderLanding()}
    </>
  );
}
